import React from 'react';
import ParametroCotaFinanciamentoService from '../../../../lib/api/parametroCotaFinanciamento/parametroCotaFinanciamentoService';
import TemplateParametro from '../shared/templateParametros/templateParametros';

class ParametroCotaFinanciamento extends React.Component<{},{}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {};
    }

    baixarExcelParametrosCotaFinanciamento()
    {
        return ParametroCotaFinanciamentoService.obterExcel()
    }

    enviarParametrosEventGrid() 
    {
        return ParametroCotaFinanciamentoService.enviarParametrosAoEventGrid();
    }
    
    render() 
    {
        return (
            <TemplateParametro
                enviarParametrosEventGrid={this.enviarParametrosEventGrid}
                baixarExcelParametros={this.baixarExcelParametrosCotaFinanciamento}
                enviarExcelParametros={ParametroCotaFinanciamentoService.enviarExcelParametros}
                deletarExcelParametros={ParametroCotaFinanciamentoService.deletarExcelParametros}
                nomeDoArquivo='Parametro Cota de Financiamento'
            ></TemplateParametro>
        );
    }
}

export default ParametroCotaFinanciamento